import React, { Component } from 'react';
import { trackEvent } from 'react-with-analytics';
import Cookies from 'js-cookie';
import ReCAPTCHA from 'react-google-recaptcha';

import '../css/components/Formulaire.css';

import ZigZag from './ZigZag';

const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const encode = (data) => {
    return Object.keys(data)
        .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
        .join("&");
}

class FormulaireDeDevis extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };

        this.show = props.show;

        this.jsonData = [
            { 'key': 'prestation de service', 'selected': false },
            { 'key': 'solutions web', 'selected': false },
            { 'key': 'solutions métier', 'selected': false },
            { 'key': 'solutions mobiles', 'selected': false },
            { 'key': 'conseil et accompagnement numérique', 'selected': false },
            { 'key': 'conception et développement numérique', 'selected': false },
            { 'key': 'UX/UI et identité visuelle', 'selected': false },
            { 'key': 'audit', 'selected': false },
            { 'key': 'expertise infrastructure/système/cloud', 'selected': false },
            { 'key': 'e-commerce omnicanal', 'selected': false },
            { 'key': 'devops', 'selected': false }
        ];

        this.onCancel = props.onCancel;

        this.selectTag = this.selectTag.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    selectTag(index) {
        this.jsonData[index].selected = !this.jsonData[index].selected;

        var hints = [];
        var interests = [];
        for (let index = 0; index < this.jsonData.length; index++) {
            if (this.jsonData[index].selected) {
                interests.push('1');
                hints.push(this.jsonData[index].key);
            } else {
                interests.push('0');
            }
        }

        var newState = this.state;
        newState['interests'] = interests;
        newState['hints'] = hints.join(', ');
        this.setState(newState);
    }

    handleChange(event) {
        var newState = this.state;
        newState[event.target.name] = event.target.value;
        this.setState(newState);
    }

    handleRecaptcha = value => {
        var newState = this.state;
        newState['g-recaptcha-response'] = value;
        this.setState(newState);
    };

    handleSubmit(event) {
        event.preventDefault();
        let localState = this.state;

        if (!localState.consents) {
            return;
        }

        trackEvent('Interactions', 'Envoi de formulaire', 'Formulaire de devis');

        let cookieVisitor = Cookies.get('visitor');
        let visitor = cookieVisitor ? cookieVisitor.split('---')[0] : '';

        let data = {
            'form_id': '5db0306654067a6683055975',
            'content_web_form_id': '5db15d9ef420872e59df7bd5',
            'visitor': visitor,
            'first_name': localState.firstname,
            'last_name': localState.lastname,
            'company': localState.company,
            'mobile': localState.phone,
            'email': localState.email,
            'interests[0]': localState['interests'],
            'consents[0]': localState.consents ? 1 : 0,
            'message': localState.message
        }

        let interests = localState['interests'] || [];
        for (let index = 0; index < interests.length; index++) {
            data['interests[' + index + ']'] = interests[index];
        }

        fetch('https://app.plezi.co/api/v1/create_contact_after_webform?' + encode(data), {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-Tenant-Company': 'Arca Computing',
                'X-API-Key': 'y1F7A5sMce8jydk5TwfT'
            }
        })
        .then((data) => {
            this.netlifySubmit();
        })
        .catch(error => {
            console.log(error)
            this.netlifySubmit();
        });
    }

    netlifySubmit() {
        fetch("/", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: encode({ "form-name": "devis", ...this.state })
        })
        .then((data) => {
            this.onCancel();
        })
        .catch(error => console.log(error));
    }

    allTags() {
        let rows = [];

        for (let index = 0; index < this.jsonData.length; index++) {
            rows.push(<span key={this.jsonData[index].key} className={"selectable-tag " + (this.jsonData[index].selected ? 'selected' : '')} onClick={() => this.selectTag(index)}>{this.jsonData[index].key}</span>)
        }

        return rows;
    }

    componentWillReceiveProps(newProps){
        this.show = newProps.show;
        this.forceUpdate();
    }

  render() {
        return (
            this.show ? (
                <div className="form-container">
                    <div className="form-overlay" onClick={this.onCancel} />
                    <div className="form">
                        <div onClick={this.onCancel} className="form-close">&#215;</div>
                        <div className="form-content">
                            <section className="form-header bloc-texte">
                                <ZigZag />
                                <h2>Parlons-en !</h2>
                                <ZigZag />
                                <p>
                                    Vous souhaitez nous consulter dans le cadre de vos projets de transformation digitale ?
                                    <br />
                                    Contactez-nous et nous reviendrons vers vous au plus vite.
                                </p>
                            </section>
                            <form onSubmit={this.handleSubmit} netlify netlify-recaptcha netlify-honeypot="bot-field">
                                <div className="recaptcha">
                                    <ReCAPTCHA ref="recaptcha" sitekey={RECAPTCHA_KEY} onChange={this.handleRecaptcha} />
                                </div>

                                <h3>Vous :</h3>
                                <div className="input-group">
                                    <input type="email" name="email" onChange={this.handleChange} placeholder="E-mail" required />
                                </div>
                                <div className="input-group">
                                    <input type="text" name="lastname" onChange={this.handleChange} placeholder="Nom" required />
                                    <input type="text" name="firstname" onChange={this.handleChange} placeholder="Prénom" required />
                                </div>
                                <div className="input-group">
                                    <input type="text" name="company" onChange={this.handleChange} placeholder="Société" required />
                                    <input type="phone" name="phone" onChange={this.handleChange} placeholder="Téléphone" required />
                                </div>
                                <h3>Votre besoin :</h3>
                                <p>Merci de qualifier votre besoin. Voici nos suggestions :</p>
                                <div className="bloc-tags">
                                    {this.allTags()}
                                </div>
                                <h3>Informations complémentaires :</h3>
                                <textarea name="message" placeholder="Complétez votre demande si nécessaire." onChange={this.handleChange}></textarea>

                                <p class="small">En soumettant ce formulaire, j'accepte que les informations saisies soient exploitées dans le cadre de la relation commerciale qui peut en découler.</p>
                                <p class="small">
                                    <label>
                                        <input type="checkbox" name="consents" onChange={this.handleChange} placeholder="Consentement" />
                                        J'ai pris connaissance de la politique de confidentialité et j'autorise ARCA Computing à m'envoyer des informations
                                    </label>
                                </p>
                                <button type="submit" className="btn btn-black">Envoyer</button>
                            </form>
                        </div>
                    </div>
                </div>
            ) : null
        );
  }
}

export default FormulaireDeDevis;



// WEBPACK FOOTER //
// ./src/components/FormulaireDeDevis.js